import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import changeTrackable, { IChangeTrackable } from './changeTrackable';
import model from './model';

type ScheduleItemType = 'proposed-delivery' | 'scheduled-delivery' | 'est-substantial-completion';

const TYPES: Record<string, ScheduleItemType> = {
	PROPOSED_DELIVERY: 'proposed-delivery',
	SCHEDULED_DELIVERY: 'scheduled-delivery',
	EST_SUBSTANTIAL_COMPLETION: 'est-substantial-completion'
};
export interface IJobCostScheduleItem extends IModel, IChangeTrackable {
	date?: Date;
	description?: string;
	type?: ScheduleItemType
}

const scheduleItemFactory = Object.assign(modelFactory.createFactory<IJobCostScheduleItem>('ScheduleItem', _.assign({}, model, changeTrackable, {
	date: {
		setFilters: valueFilters.toDate,
		rules: validator.date()
	},
	description: {
		setFilters: valueFilters.toString
	},
	type: {
		setFilters: valueFilters.clean
	}
})), { TYPES });

export default scheduleItemFactory;